/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const ArrowLeft = ({ color = 'forest', height = 11, ...props }) => {
  return (
    <svg
      width={20}
      height={height}
      viewBox="0 0 20 11"
      sx={{ fill: color }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.657 11L7.071 9.46965L3.829 6.17544H20V4.24561H3.829L7.071 1.28237L5.657 0L0 5.25105L5.657 11Z"
      />
    </svg>
  )
}

ArrowLeft.propTypes = {
  color: string,
  height: number,
}

export default ArrowLeft
